import { FormInput } from "../../../../components/ui/Input/FormInput/FormInput";
import { FormInputNumber } from "../../../../components/ui/Input/FormInputNumber/FormInputNumber";
import { Card, CardContent, CardHeader } from "../../../../components/ui/common/card";
import { Label } from "../../../../components/ui/common/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "../../../../components/ui/common/select";
import { IngredientRegisterViewModel } from "../types/ingredientRegisterView.types";

interface UnitDetailsCardProps {
  vm: IngredientRegisterViewModel;
}

/**
 * "UNIT DETAILS" card — only appears once a supplier is selected/created,
 * matching legacy's `!isEmpty(supplierData)` gate. Most fields use the
 * shared `FormInput`/`FormInputNumber` (src/components/ui/Input/), bound via
 * `vm.control`. "Unit Type" is a plain controlled `Select` bound directly to
 * `vm.defaultType`/`vm.onDefaultTypeChange` instead — same pattern as the
 * product register's `ProductUnitCard` — since this card can mount well
 * after `defaultType` is first set, and a plain controlled value can't go
 * stale the way an RHF field registered late can.
 */
const UnitDetailsCard = ({ vm }: UnitDetailsCardProps) => {
  if (!vm.showUnitDetails) return null;

  return (
    <Card className="tw-gap-3 tw-py-4">
      <CardHeader className="tw-px-4">
        <span className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-muted-foreground">
          Unit Details
        </span>
      </CardHeader>
      <CardContent className="tw-px-4">
        <div className="tw-grid tw-grid-cols-2 tw-gap-3 md:tw-grid-cols-4">
          <FormInputNumber
            control={vm.control}
            name="unit_size"
            label="Unit Size"
            required
            placeholder="Unit Size"
          />
          <div className="tw-space-y-2">
            <Label>Unit Type</Label>
            <Select value={vm.defaultType} onValueChange={vm.onDefaultTypeChange}>
              <SelectTrigger className="tw-w-full !tw-h-10">
                <SelectValue placeholder="Select unit type" />
              </SelectTrigger>
              <SelectContent>
                {vm.unitTypeOptions.map(option => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.text}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <FormInput
            control={vm.control}
            name="ean_bar_code"
            label="EAN Barcode"
            placeholder="optional"
          />
          <FormInput
            control={vm.control}
            name="product_id"
            label="Product ID"
            placeholder="optional"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default UnitDetailsCard;
